import { SupportedLanguages } from "integration/api/models";

export const supportedLanguagesArray = Object.keys(SupportedLanguages) as SupportedLanguages[];
